export default "__VITE_ASSET__CWANsGi9__"